module.exports = __webpack_public_path__ + "img/Tooltip.5f85eadf.svg";